import { defineMessages } from "react-intl";

import {
	calciumActiveIngredientMessages,
	drugTypeMessages,
	erythropoetinProductActiveIngredientMessages,
	validator,
	vitaminDactiveIngredientMessages
} from "lib/build/forms/ktx/transplantation-screening/medical-history/medicalTreatment";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	empty: {
		id: "ktx.form.medicalTreatment.emtpy",
		defaultMessage: ""
	},
	medicalTreatment: {
		id: "ktx.form.medicalTreatment.title",
		defaultMessage: "Gyógyszeres kezelés"
	},
	drugType: {
		id: "ktx.form.medicalTreatment.drug_type",
		defaultMessage: "Gyógyszer csoport"
	},
	calciumActiveIngredient: {
		id: "ktx.form.medicalTreatment.calcium_active_ingredient",
		defaultMessage: "Hatóanyag"
	},
	vitaminDActiveIngredient: {
		id: "ktx.form.medicalTreatment.vitamin_d_active_ingredient",
		defaultMessage: "Hatóanyag"
	},
	vitaminDActiveIngredientOther: {
		id: "ktx.form.medicalTreatment.vitamin_d_active_ingredient_other",
		defaultMessage: "Egyéb hatóanyag"
	},
	erythropoetinProductActiveIngredientOther: {
		id: "ktx.form.medicalTreatment.erythropoetin_product_active_ingredient_other",
		defaultMessage: "Egyéb hatóanyag"
	},
	erythropoetinProductActiveIngredient: {
		id: "ktx.form.medicalTreatment.erythropoetin_product_active_ingredient",
		defaultMessage: "Hatónyag"
	},
	other: {
		id: "ktx.form.medicalTreatment.other",
		defaultMessage: "Egyéb"
	}
});

const drugTypeField: FieldData = {
	type: "field",
	path: ["drugType"],
	label: messages.drugType,
	errorMessages: genericErrorMessages,
	input: {
		type: "select",
		props: {
			labels: drugTypeMessages
		}
	}
};

const calciumActiveIngredientField: FieldData = {
	type: "field",
	path: ["calciumActiveIngredient"],
	label: messages.calciumActiveIngredient,
	errorMessages: genericErrorMessages,
	input: {
		type: "checkbox-group",
		props: {
			labels: calciumActiveIngredientMessages,
			direction: "vertical",
			columns: 2
		}
	}
};

const vitaminDActiveIngredientField: FieldData = {
	type: "field",
	path: ["vitaminDActiveIngredient"],
	label: messages.vitaminDActiveIngredient,
	errorMessages: genericErrorMessages,
	input: {
		type: "checkbox-group",
		props: {
			labels: vitaminDactiveIngredientMessages,
			direction: "vertical",
			columns: 2
		}
	}
};

const vitaminDActiveIngredientOtherField: FieldData = {
	type: "field",
	path: ["vitaminDActiveIngredientTypeOther"],
	label: messages.vitaminDActiveIngredientOther,
	errorMessages: genericErrorMessages,
	input: { type: "input", props: { type: "text" } }
};

const erythropoetinProductActiveIngredientOtherField: FieldData = {
	type: "field",
	path: ["erythropoetinProductActiveIngredientTypeOther"],
	label: messages.erythropoetinProductActiveIngredientOther,
	errorMessages: genericErrorMessages,
	input: { type: "input", props: { type: "text" } }
};

const erythropoetinProductActiveIngredientField: FieldData = {
	type: "field",
	path: ["erythropoetinProductActiveIngredient"],
	label: messages.erythropoetinProductActiveIngredient,
	errorMessages: genericErrorMessages,
	input: {
		type: "checkbox-group",
		props: {
			labels: erythropoetinProductActiveIngredientMessages,
			direction: "vertical",
			columns: 2
		}
	}
};

const otherField: FieldData = {
	type: "field",
	path: ["drugTypeOther"],
	label: messages.other,
	errorMessages: genericErrorMessages,
	input: {
		type: "textarea",
		props: {}
	}
};

const fieldset: FieldsetData = {
	rows: [
		{
			columns: [
				{
					width: 12,
					field: {
						type: "field-group-list",
						path: ["drugTypes"],
						label: messages.empty,
						rows: [
							{
								columns: [{ width: 12, field: drugTypeField }]
							},
							{
								columns: [
									{
										width: 12,
										field: calciumActiveIngredientField
									}
								]
							},
							{
								columns: [
									{
										width: 12,
										field: vitaminDActiveIngredientField
									}
								]
							},
							{
								columns: [
									{
										width: 12,
										field: vitaminDActiveIngredientOtherField
									}
								]
							},
							{
								columns: [
									{
										width: 12,
										field: erythropoetinProductActiveIngredientField
									}
								]
							},
							{
								columns: [
									{
										width: 12,
										field: erythropoetinProductActiveIngredientOtherField
									}
								]
							},
							{
								columns: [
									{
										width: 12,
										field: otherField
									}
								]
							}
						]
					}
				}
			]
		}
	]
};

export const node: LeafNode = {
	id: "ktx_medicalTreatment",
	value: {
		schemaId: "medicalTreatment",
		title: messages.medicalTreatment,
		validator,
		fieldset,
		applyCurrentDate: true,
		initialValue: { drugTypes: [{}] },
		defaults: [
			{
				path: [],
				query: {
					interpretation: {
						vocab: "ktx",
						code: "medical_treatment_statement"
					}
				}
			}
		]
	}
};
